export function changeAlpha(rgba, alpha) {
    return rgba.replace(/^rgba[(]\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*[)]$/, `rgba($1,$2,$3,${alpha})`);
}
// возвращает цвет получаемый наложением двух других цветов
export function blend(targetRgbaColor, overlayRgbaColor) {
    if (targetRgbaColor.startsWith('#')) {
        targetRgbaColor = hexToRgba(targetRgbaColor);
    }
    if (overlayRgbaColor.startsWith('#')) {
        overlayRgbaColor = hexToRgba(overlayRgbaColor);
    }
    const match1 = /^rgba[(]\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*[)]$/.exec(targetRgbaColor);
    const match2 = /^rgba[(]\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*[)]$/.exec(overlayRgbaColor);
    if (!(match1 === null || match1 === void 0 ? void 0 : match1.length) || !(match2 === null || match2 === void 0 ? void 0 : match2.length)) {
        return targetRgbaColor;
    }
    const [, r1, g1, b1, a1] = match1.map(Number);
    const [, r2, g2, b2, a2] = match2.map(Number);
    const a = (1 - a2) * a1 + a2;
    const r = Math.floor(((1 - a2) * a1 * r1 + a2 * r2) / a);
    const g = Math.floor(((1 - a2) * a1 * g1 + a2 * g2) / a);
    const b = Math.floor(((1 - a2) * a1 * b1 + a2 * b2) / a);
    return `rgba(${r},${g},${b},${a})`;
}
export const calcAlphaShade = (colorRGBA, alpha) => +(colorRGBA * alpha + 255 * (1 - alpha)).toFixed(0);
export const calcHex = (color) => ('0' + color.toString(16)).slice(-2);
export const convertRGBAToHex = (color) => {
    const match = /^rgba[(]\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*[)]$/.exec(color);
    if (!match) {
        return;
    }
    const [r, g, b, a] = match.slice(1).map(Number);
    const res = [r, g, b].map(c => calcHex(calcAlphaShade(c, a)));
    return `#${res.join('')}`;
};
export function hexToChannel(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex) || /^#?([a-f\d])([a-f\d])([a-f\d])$/i.exec(hex);
    if (!result)
        throw new Error('Expected hex format, instead got ' + hex);
    const r = parseInt(result[1].padEnd(2, result[1]), 16);
    const g = parseInt(result[2].padEnd(2, result[2]), 16);
    const b = parseInt(result[3].padEnd(2, result[3]), 16);
    return { r, g, b };
}
export function hexToRgba(hex, alpha = 1) {
    const { r, g, b } = hexToChannel(hex);
    return `rgba(${r},${g},${b},${alpha})`;
}
export function invertHex(hex) {
    const { r, g, b } = hexToChannel(hex);
    return `#${(255 - r).toString(16).padStart(2, '0')}${(255 - g).toString(16).padStart(2, '0')}${(255 - b).toString(16).padStart(2, '0')}`;
}
